import { render, staticRenderFns } from "./FontLineHeight.vue?vue&type=template&id=4399a1bf&"
import script from "./FontLineHeight.vue?vue&type=script&lang=js&"
export * from "./FontLineHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports